var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { Paper, Popper as MuiPopper, styled } from '@mui/material';
import React, { useState } from 'react';
import { rem } from '../../utils/rem';
var Popper = styled(MuiPopper, {
    shouldForwardProp: function (prop) { return prop !== 'arrow'; },
})(function (_a) {
    var theme = _a.theme, arrow = _a.arrow;
    return ({
        zIndex: 1,
        '& > div': {
            position: 'relative',
        },
        '&[data-popper-placement*="bottom"]': {
            '& > div': {
                marginTop: rem(arrow ? 12 : 0),
            },
            '& .MuiPopper-arrow': {
                filter: 'drop-shadow(0px -4px 5px rgb(0 0 0 / 30%))',
                top: 0,
                left: 0,
                marginTop: '-0.9em',
                width: '3em',
                height: '1em',
                '&::before': {
                    borderWidth: '0 1em 1em 1em',
                    borderColor: "transparent transparent ".concat(theme.palette.background.paper, " transparent"),
                },
            },
        },
        '&[data-popper-placement*="top"]': {
            '& > div': {
                marginBottom: rem(arrow ? 12 : 0),
            },
            '& .MuiPopper-arrow': {
                filter: 'drop-shadow(0px 4px 5px rgb(0 0 0 / 30%))',
                bottom: 0,
                left: 0,
                marginBottom: '-0.9em',
                width: '3em',
                height: '1em',
                '&::before': {
                    borderWidth: '1em 1em 0 1em',
                    borderColor: "".concat(theme.palette.background.paper, " transparent transparent transparent"),
                },
            },
        },
        '&[data-popper-placement*="right"]': {
            '& > div': {
                marginInlineStart: rem(arrow ? 12 : 0),
            },
            '& .MuiPopper-arrow': {
                filter: 'drop-shadow(-4px 0px 5px rgb(0 0 0 / 30%))',
                left: 0,
                marginInlineStart: '-0.9em',
                height: '3em',
                width: '1em',
                '&::before': {
                    borderWidth: '1em 1em 1em 0',
                    borderColor: "transparent ".concat(theme.palette.background.paper, " transparent transparent"),
                },
            },
        },
        '&[data-popper-placement*="left"]': {
            '& > div': {
                marginInlineEnd: rem(arrow ? 12 : 0),
            },
            '& .MuiPopper-arrow': {
                filter: 'drop-shadow(4px 0px 5px rgb(0 0 0 / 30%))',
                right: 0,
                marginInlineEnd: '-0.9em',
                height: '3em',
                width: '1em',
                '&::before': {
                    borderWidth: '1em 0 1em 1em',
                    borderColor: "transparent transparent transparent ".concat(theme.palette.background.paper),
                },
            },
        },
        '& [class*=MuiDialogTitle-root]  [class*=MuiTypography-root]': {
            padding: rem(16),
            paddingBottom: 0,
            fontSize: '1rem',
        },
        '& [class*=MuiDialogContent-root]': {
            paddingBlock: rem(8),
            paddingInline: rem(16),
        },
    });
});
var Arrow = styled('div')({
    position: 'absolute',
    fontSize: rem(7),
    width: '3em',
    height: '3em',
    '&::before': {
        content: '""',
        margin: 'auto',
        display: 'block',
        width: 0,
        height: 0,
        borderStyle: 'solid',
    },
});
var Popover = function (_a) {
    var children = _a.children, _b = _a.arrow, arrow = _b === void 0 ? true : _b, _c = _a.modifiers, modifiers = _c === void 0 ? [] : _c, paperProps = _a.paperProps, props = __rest(_a, ["children", "arrow", "modifiers", "paperProps"]);
    var _d = useState(null), arrowRef = _d[0], setArrowRef = _d[1];
    return (React.createElement(Popper, __assign({}, __assign({ arrow: arrow }, props), { modifiers: __spreadArray([
            {
                name: 'arrow',
                enabled: arrow,
                options: {
                    element: arrowRef,
                },
            }
        ], modifiers, true) }),
        React.createElement("div", null,
            arrow ? React.createElement(Arrow, { ref: setArrowRef, className: "MuiPopper-arrow" }) : null,
            React.createElement(Paper, __assign({ elevation: 6 }, paperProps), children))));
};
export default Popover;
